import { connect } from 'react-redux';
import { getListBillerByService } from 'redux/actions/BillerAction';
import { getService } from 'redux/actions/ServiceAction';
import { getAuthToken } from 'redux/actions/GeneralAction';
import { injectIntl } from 'react-intl';
import BillerPage from './BillerPage.page';

const page = injectIntl(BillerPage);
const mapStateToProps = state => ({
  isLoading: state.general.isLoading,
  deviceHeight: state.general.deviceHeight,
  billerList: state.biller.billerList,
  service: state.service.service,
});

const mapDispatchToProps = { getListBillerByService, getService, getAuthToken };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(page);
